/**
 * `ApiError` builds its message as `API error <status>: <detail>`, where the
 * detail is the server's own sentence about what was wrong with the request,
 * or as the status line alone when the server said nothing more.
 */
const API_ERROR_MESSAGE = /^(API error \d+)(?:: .*)?$/s;

/**
 * The status line of an API failure's message, without what the server said;
 * `null` for any other message.
 *
 * Uncaught rejections of an `ApiError` carry its message, and a save can be
 * rejected precisely for quoting the draft back. The mutation path already
 * withholds that; this is the same rule for the failures nobody caught.
 */
export function apiErrorStatus(message: unknown): string | null {
  if (typeof message !== "string") return null;
  return API_ERROR_MESSAGE.exec(message)?.[1] ?? null;
}
